<div class="p-7 w-[400px] max-w-[90vw]">
  <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] m-0 mb-2">{{ dialogTitle }}</p>
  <p class="text-sm text-[var(--base-text-alt-dark)] leading-relaxed">{{ dialogSubTitle }}</p>

  <div class="flex justify-end gap-3 mt-6">
    <button (click)="closeDialog(false)" class="px-5 py-2.5 rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] transition">Cancel</button>

    <button *ngIf="dialogType === 'back'" (click)="closeDialog(true)"
      class="px-5 py-2.5 rounded-lg text-[13px] font-medium border-2 border-[var(--primary-dark)] text-[var(--primary-dark)] hover:bg-[var(--app-base)] transition">Back</button>

    <button *ngIf="dialogType === 'delete' || dialogType === 'remove' || dialogType === 'reject'" (click)="closeDialog(true)"
      class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--notification-error)] text-white hover:opacity-90 transition">
      {{dialogType === 'remove' ? 'Remove' : (dialogType === 'reject' ? 'Reject' : 'Delete')}}
    </button>

    <button *ngIf="dialogType === 'save' || dialogType === 'approve'" (click)="closeDialog(true)"
      class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--primary-dark)] text-white hover:opacity-90 transition">
      {{dialogType === 'save' ? 'Save' : 'Approve'}}
    </button>

    <!-- Generic confirm. Label comes from the caller so a new action does not
         need its own dialogType. Additive: every existing type is untouched. -->
    <button *ngIf="dialogType === 'confirm'" (click)="closeDialog(true)"
      class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--primary-dark)] text-white hover:opacity-90 transition">{{ confirmText || 'Confirm' }}</button>

    <button *ngIf="dialogType === 'submit'" (click)="closeDialog(true)"
      class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--notification-success)] text-white hover:opacity-90 transition">Submit</button>
  </div>
</div>
